import React from 'react';
import { motion } from 'framer-motion';
export function BonusGridSection() {
  const bonuses = [{
    id: 1,
    title: '50 Merende Pronte in 5 Minuti',
    desc: 'Idee velocissime per quando non hai tempo.',
    image: 'https://cdn.magicpatterns.com/uploads/m5b8QEbh8QfX6ewE34sgMs/bono_2.webp'
  }, {
    id: 2,
    title: 'Bambini Schizzinosi?',
    desc: 'Il Metodo Gentile per Far Amare Frutta e Verdura.',
    image: 'https://cdn.magicpatterns.com/uploads/69YK5GgH7jBDAvj7NKtTeH/bono_1.webp'
  }, {
    id: 3,
    title: 'Snack Senza Zuccheri Raffinati',
    desc: '60 Ricette Naturali e Deliziose.',
    image: 'https://cdn.magicpatterns.com/uploads/vg1zbBU4Khv15tuVpKZieL/bono_3.webp'
  }, {
    id: 4,
    title: 'Il Freezer della Mamma Organizzata',
    desc: '100 Preparazioni da Congelare.',
    image: 'https://cdn.magicpatterns.com/uploads/mywV3GwsHxFbV7RYTEaXPH/bono_4.webp'
  }, {
    id: 5,
    title: '365 Giorni di Ispirazione',
    desc: "Un'Idea Nuova Ogni Giorno per Tutto l'Anno.",
    image: 'https://cdn.magicpatterns.com/uploads/jHJaAc9Fh44pWDXFvYwrhp/bono_5.webp'
  }];
  return <section className="bg-[#1f2e10] py-20 px-4" data-id="element-26">
      <div className="max-w-6xl mx-auto" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <p className="text-[#c4f000] font-bold text-xl mb-2 tracking-widest" data-id="element-29">
            E IN PIÙ...
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white" data-id="element-30">
            OGGI RICEVI ANCHE
            <br data-id="element-31" />
            <span className="text-[#c4f000]" data-id="element-32">5 BONUS ESCLUSIVI</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto justify-center" data-id="element-33">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-white rounded-2xl overflow-hidden shadow-xl flex flex-col ${idx === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-34">
              <div className="relative w-full aspect-[4/3] bg-gray-100" data-id="element-35">
                <div className="absolute top-4 left-4 bg-red-500 text-white text-xs font-black px-3 py-1.5 rounded-full transform -rotate-6 z-10 shadow-lg" data-id="element-36">
                  BONUS #{bonus.id}
                </div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-37" />
              </div>
              <div className="p-6 flex flex-col flex-grow text-center" data-id="element-38">
                <h3 className="font-black text-xl text-[#1f2e10] mb-3 leading-tight" data-id="element-39">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed font-medium" data-id="element-40">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}